var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.839 5.71433L7.46403 10.0893C7.40306 10.1505 7.33062 10.1991 7.25085 10.2322C7.17108 10.2653 7.08556 10.2823 6.99919 10.2823C6.91281 10.2823 6.82729 10.2653 6.74752 10.2322C6.66775 10.1991 6.59531 10.1505 6.53434 10.0893L2.15934 5.71433C2.03606 5.59105 1.9668 5.42384 1.9668 5.24949C1.9668 5.07514 2.03606 4.90793 2.15934 4.78464C2.28263 4.66136 2.44984 4.5921 2.62419 4.5921C2.79854 4.5921 2.96574 4.66136 3.08903 4.78464L6.99973 8.69535L10.9104 4.7841C11.0337 4.66081 11.2009 4.59155 11.3753 4.59155C11.5496 4.59155 11.7168 4.66081 11.8401 4.7841C11.9634 4.90738 12.0327 5.07459 12.0327 5.24894C12.0327 5.42329 11.9634 5.5905 11.8401 5.71378L11.839 5.71433Z",
    fill: "#44546F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/CaretDown.967cba4b6d2eac83a99faee89b7462b5.svg";
export { ForwardRef as ReactComponent };